export default __webpack_public_path__ + "static/fonts/CamphorPro-Medium.b35e876.woff";